import React, { memo, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import DonutChart from "src/modules/data-protection/pages/admin/dashboard/components/ApexChart/DonutChart";
import {
    AI_TASK_PRIORITY_COLOR,
    AI_TASK_PRIORITY_ORDER,
} from "../ai-risk-chart-constants";

const TaskPriorityOverview = memo(({ t, data, isFetching }) => {
    const items = Array.isArray(data) ? data : [];
    const byPriorityMap = useMemo(
        () => Object.fromEntries(items.map((row) => [row.priority, row])),
        [items]
    );

    const chartCategories = useMemo(
        () =>
            AI_TASK_PRIORITY_ORDER.map((priority) => {
                const row = byPriorityMap[priority];
                return {
                    priority,
                    title:
                        priority === "high"
                            ? "High"
                            : priority === "medium"
                              ? "Medium"
                              : "Low",
                    amount: Number(row?.amount) || 0,
                    percent: Number(row?.percent) || 0,
                };
            }),
        [byPriorityMap]
    );
    const chartColors = useMemo(
        () =>
            chartCategories.map(
                (row) => AI_TASK_PRIORITY_COLOR[row.priority] || "#90A4AE"
            ),
        [chartCategories]
    );

    if (isFetching) {
        return <div className="dt-field dt-skeleton mb-3" style={{ width: "100%", height: "460px" }} />;
    }

    return (
        <DonutChart
            title={t("Task Priority Overview")}
            categories={chartCategories}
            colors={chartColors}
            cardStyle={{ height: "460px" }}
            bodyStyle={{ height: "100%" }}
        />
    );
});

export default withNamespaces()(TaskPriorityOverview);
